<script>
//MediaFacet.vue
import TransitionCollapseHeight from "./../TransitionCollapseHeight"

import SingleList from "./SingleList";
import MultiList from "./MultiList";
import ToggleButton from "./ToggleButton";
import DateRange from "./DateRange";
import SimpleText from "./SimpleText";

export default {
    components: {
        TransitionCollapseHeight,
        SingleList,
        MultiList,
        ToggleButton,
        DateRange,
        SimpleText,
    },
    props: {
        facetName: String,
        aggregations: {
            type: Object,
            required: true
        },
        facets: Object,
        filter: Object,
        raw: Boolean,
    },
    data() {
        return {
            id: _.uniqueId(),
            showFacet: this.selectedValue ? true : false,
            baseUrl: Scoop.baseUrl,
            loading: false,
            activeFacet: true,
        }
    },
    created() {
        this.showFacet = this.selectedValue ? true : false;
    },
    computed: {
        selectedValue: {
            get: function () {
                return this.filter[this.filterAlias ? this.filterAlias : this.facetName];//.replace(/['"]+/g, '');
            },
            set: function (newValue) {
                this.$emit('filter-changed', this.facetName, newValue);
            }
        },
        clearedFilter() {
            return _.pickBy(this.filter, value => value !== null);  // Remove null values
        },
        facetConfiguration() {
            return this.facets[this.facetName] ? this.facets[this.facetName] : null;
        },
        facetType() {
            return this.facetConfiguration ? this.facetConfiguration.facetType : null;
        },
        facetTitle() {
            return  this.facetConfiguration ? this.facetConfiguration.facetTitle : null;
        },
        limitOptions() {
            return    this.facetConfiguration ? this.facetConfiguration.limitOptions : null;
        },
        filterAlias() {
            return   this.facetConfiguration ? this.facetConfiguration.filterAlias: null;
        },
        filterOptions() {
            return   this.facetConfiguration ? this.facetConfiguration.filterOptions : null;
        },
        defaultOption() {
            return   this.facetConfiguration ? this.facetConfiguration.defaultOption : null;
        },
        showCounts() {
            return   this.facetConfiguration ? this.facetConfiguration.showCounts : null;
        },
        buckets() {
            let aggregation = this.aggregations[this.facetName];

            if (_.has(aggregation, this.facetName)) {
                aggregation = aggregation[this.facetName];

            }
            if (!aggregation) {
                return [];
            }
            if (_.has(aggregation, '_label')) {
                aggregation = aggregation['_label'];
            }
            return aggregation.buckets;
        },
        options() {
            if (this.facetType === 'ToggleButton') {
                return this.facetConfiguration.options;
            }

            let values = _.values(_.mapValues(this.buckets, bucket => {

                let label = bucket.key;

                if (_.has(bucket, 'label')) { // Is a key/value aggregation
                    label = bucket.label.hits.hits[0]._source.label;
                }

                return {
                    'value': bucket.key,
                    'text': bucket.doc_count ? label + ' (' + bucket.doc_count + ')' : label,
                    'text_without_count': label,
                    'count': bucket.doc_count
                }
            }));

            if (values.length == 0 && this.facetType !== 'DateRange' ) {
                this.activeFacet = false;
            }
            else{
                this.activeFacet = true;
            }
            return values;
        },
        facetClass() {
            if(this.selectedValue){
                //this.$emit('group-open',this.facetName ); //erfordert Änderung in jeder manuellen Platzierung
                //scoopOS.$emit("openFacetGroup"); // schmeisst den event und ALLE Groups reagieren drauf...
                this.$parent.$parent.groupOpen();  // nur der Parent reagiertm so passsts auch (erstmal)
                return this.raw ? "media-facet-raw-active" : "media-facet-group-active";
            }
            if(this.raw) {
                return this.activeFacet ? "media-facet-raw" : "media-facet-raw-disabled";
            }
            else{
                return this.activeFacet ? "media-facet-group" : "media-facet-group-disabled";
            }
        },
        titleClass() {
            if(this.selectedValue){
                return "title-active";
            }
            if(this.raw) {
                return this.activeFacet ? "title" : "title-disabled";
            }
            else{
                return this.activeFacet ? "title" : "title-disabled";
            }
        },
    },
    watch: {
        filter(value) {
            if(value.reset){
                this.showFacet = false;
                scoopOS.$emit("closeAllFacetGroups");
            }
        }
    },

    methods: {
        toggleFacet() {
            this.showFacet = !this.showFacet
        },

        search() {
            this.$emit('searchAgain');
        },
        resetFilter() {
            this.$emit('reset');
        }
    },
}
</script>

<template>
    <div>

        <div v-if="!raw && facetTitle" :class="facetClass">
            <div :class="titleClass" v-on:click="toggleFacet">
                {{ this.facetTitle }}<span class="pull-right">
                                    <i v-if="activeFacet" :class="[showFacet ? 'fa fa-chevron-up' : 'fa fa-chevron-down']"></i>
                                </span>
            </div>
            <TransitionCollapseHeight>
                <div v-show="showFacet" class="content">
                    <component
                        :is="facetType"
                        :facet-title="facetTitle"
                        :filter="filter"
                        :options="options"
                        :limitOptions="limitOptions"
                        :filterOptions="filterOptions"
                        :defaultOption="defaultOption"
                        :showCounts="showCounts"
                        :activeFacet="activeFacet"
                        v-model="selectedValue"
                        @search="search"
                        :key="'facet_'+facetName+'_'+id"
                    />
                </div>
            </TransitionCollapseHeight>
        </div>

        <div v-if="raw && facetTitle" :class="facetClass">
            <div :class="titleClass">
            <slot name="title">
                {{ facetTitle }}
            </slot>
            </div>
            <component
                :is="facetType"
                :facet-title="facetTitle"
                :filter="filter"
                :options="options"
                :limitOptions="limitOptions"
                :filterOptions="filterOptions"
                :defaultOption="defaultOption"
                :showCounts="showCounts"
                :activeFacet="activeFacet"
                v-model="selectedValue"
                @search="search"
                :key="'facet_'+facetName+'_'+id"
            />
            <slot name="footer">

            </slot>
        </div>
    </div>
</template>

<style>
.title {
    cursor: pointer;
    font-weight: bold;
    color: #7a797b;
    margin-top:8px;
}
.title-active {
    cursor: pointer;
    font-weight: bold;
    color: #A39577;
    margin-top:8px;
}
.title-disabled {
    cursor: pointer;
    font-weight: bold;
    color: #d2d2d2;
    margin-top:8px;
}
.media-facet-head {
    font-style: italic;
    border-bottom: 1px solid #d2d2d2;
    margin-top: 16px;
    margin-bottom: 8px;
}

.title span i {
    margin-left: 5px;
    color: #c4c4c4;
}

.media-facet-group {
    padding: 8px;
    margin-bottom:8px;
    border: 1px dashed #d2d2d2;
}

.media-facet-group-active {
    padding: 8px;
    margin-bottom:8px;
    border: 1px dashed #A39577;
}

.media-facet-group-disabled {
    padding: 8px;
    margin-bottom:8px;
    border: 1px dashed #efefef;

}

.media-facet-raw{

}
.media-facet-raw-active{

}

.media-facet-raw-disabled{

}
</style>
